export var getStartIndex = (pageSize, currentPage, totalItems) => {
  var totalPages = getTotalPages(totalItems, pageSize);
  var pageForCalculation = Math.min(currentPage, totalPages);
  return Math.max(1, 1 + pageSize * (pageForCalculation - 1));
};
export var getEndIndex = (pageSize, currentPage, totalItems) => {
  var pageForCalculation = Math.max(currentPage, 1);
  return Math.min(pageSize * pageForCalculation, totalItems);
};
export var getTotalPages = (totalItems, pageSize) => Math.ceil(totalItems / pageSize);
export var getPreviousEnabled = currentPage => currentPage > 1;
export var getNextEnabled = (currentPage, totalItems, pageSize) => {
  var totalPages = getTotalPages(totalItems, pageSize);
  return currentPage + 1 <= totalPages;
};
//# sourceMappingURL=utils.js.map